module.exports = __webpack_public_path__ + "img/ywca.865d082.png";